import { formatAmountDateBack } from '../../utils/formatUtils';

export const adapterResponseBoard = (adapterBoard) => {
  const { fecha, fechasCalendario, primeraFecha, ultimaFecha, partesDiarios, partesTotales } =
    adapterBoard;

  return {
    fecha: formatAmountDateBack(fecha),
    fechasCalendario: fechasCalendario.map((fechaCal) => formatAmountDateBack(fechaCal)),
    partesDiarios,
    partesTotales,
    primeraFecha: formatAmountDateBack(primeraFecha),
    ultimaFecha: formatAmountDateBack(ultimaFecha)
  };
};

const mapNestedItems = (items, dailyWorkReportEdited) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.map((item) => {
    if (item.idParteDiario) {
      if (dailyWorkReportEdited && item.idParteDiario === dailyWorkReportEdited) {
        return {
          ...item,
          editaAprobador: true
        };
      }

      return item;
    }

    if (item.items && Array.isArray(item.items)) {
      return {
        ...item,
        items: mapNestedItems(item.items, dailyWorkReportEdited)
      };
    }

    return item;
  });
};

export const adapterResponseWorkReport = (adapter, dailyWorkReportEdited = null) => {
  if (!adapter) {
    return {
      fecha: null,
      items: [],
      pageIndex: 0,
      totalCount: 0,
      totalPages: 0
    };
  }

  const { fecha, items, pageIndex, totalCount, totalPages } = adapter;

  const mapItems = mapNestedItems(items, dailyWorkReportEdited);

  return {
    fecha: formatAmountDateBack(fecha),
    items: mapItems,
    pageIndex,
    totalCount,
    totalPages
  };
};
